function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys1 = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys1 = ownKeys1.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys1.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import regeneratorRuntime from "regenerator-runtime";
import { defineComponent, computed, ref, toRefs, reactive, watch, onMounted, onUnmounted, nextTick, getCurrentInstance } from "vue";
import ConfirmDialog from "./batch-confirm.vue";
import UpdateDialog from "./batch-update.vue";
import UploadDialog from "./batch-upload.vue";
import { Operation, TabsType } from "../config/enums";
import { loading, fromSchemaFun, fromModel, validateModel, validateAction, getModelIfrInfo } from "../config/form";
import { delAsset, saveAsset, updateAsset, batchCreateAsset } from "@/api/public_resource";
import { playTurboHostList } from "@/config/host";
import { NODE_ENV } from "@com/config/env";
import { playsmartEntry } from "@pt/config/index";
import { templateAudit, templateStatus, updateFragment } from "@/api/veditor/index";
import { Message } from "element-ui";
import store from "@/store";
import _ from "lodash";
import { getFileExtension } from "@com/utils/file";
export default defineComponent({
    name: "resource-dialog",
    components: {
        ConfirmDialog: ConfirmDialog,
        UpdateDialog: UpdateDialog,
        UploadDialog: UploadDialog
    },
    setup: function setup(props, param) {
        var emit = param.emit, attrs = param.attrs;
        var getUrlList = function getUrlList(url, urlName, listName) {
            var urlNameList = url.split("/");
            fromModelData.fromModel[listName] = [
                {
                    name: String(urlNameList[urlNameList.length - 1].split("?")[0]),
                    url: url
                }, 
            ];
        };
        var resetForm = function resetForm() {
            var _$ref, _$ref1;
            if (!fromRef) return;
            (_$ref = fromRef.value) === null || _$ref === void 0 ? void 0 : _$ref.resetFields();
            (_$ref1 = fromRef.value) === null || _$ref1 === void 0 ? void 0 : _$ref1.clearValidate();
        };
        var validate3DModel = // 3d模型文件检验
        function validate3DModel() {
            // 模型库才会校验
            if (Number(fromModelData.fromModel.type) !== TabsType.MODEL) {
                return "";
            }
            return validateModel(fromModelData.fromModel.skeleton_type, fromModelData.fromModel.file_meta);
        };
        var validateModelAction = // 动作文件检验
        function validateModelAction() {
            // 动作库才会校验
            if (Number(fromModelData.fromModel.type) !== TabsType.ACTION) {
                return "";
            }
            return validateAction(fromModelData.fromModel.skeleton_type, fromModelData.fromModel.file_meta);
        };
        var getModelBasicInfo = function getModelBasicInfo(event) {
            if (event.data.type !== "PLAYABLE:gltfview") return;
            console.log("event", event);
            if (event.data.data.type === "modelLoadSuccess") {
                var data = event.data.data.params.info;
                var geometry = data.geometries[0];
                if (!geometry) {
                    loading.value = false;
                    return;
                }
                // console.log('data.boneNames', JSON.stringify(data.boneNames))
                fromModelData.fromModel.file_meta = _objectSpreadProps(_objectSpread({}, fromModelData.fromModel.file_meta), {
                    mesh_count: Math.floor(data.meshCount) || 0,
                    material_count: Math.floor(data.materialCount) || 0,
                    skin_count: Math.floor(data.skinCount) || 0,
                    skeleton_count: Math.floor(data.boneNames && data.boneNames.length) || 0,
                    skeleton_names: data.boneNames,
                    face_count: geometry.index ? geometry.index.count / 3 : geometry.attributes.position.positionCount / 3,
                    vertex_count: geometry.attributes.position.positionCount || 0,
                    has_vertices: geometry.attributes.position !== undefined,
                    has_normals: geometry.attributes.normal !== undefined,
                    has_UVs: geometry.attributes.uv !== undefined
                });
            } else if (event.data.data.type === "animationLoadSuccess") {
                var data1 = event.data.data.params.info;
                console.log("animationLoadSuccess", data1);
                var boneNames = data1.boneNames || [];
                // const skeleton_names = boneNames.filter((name: string) => {
                //   return (
                //     name.includes('/') &&
                //     name !==
                //       'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_Neck' &&
                //     name !==
                //       'Bip001/Bip001_Pelvis/Bip001_Spine/Bip001_Spine1/Bip001_Neck/Bip001_Head'
                //   )
                // })
                fromModelData.fromModel.file_meta = _objectSpreadProps(_objectSpread({}, fromModelData.fromModel.file_meta), {
                    skeleton_count: boneNames.length,
                    skeleton_names: boneNames,
                    mesh_count: Math.floor(data1.meshCount) || 0,
                    fps: Math.round(data1.frameRate),
                    frames: data1.frameCount
                });
            } else if (event.data.data.type === "animationLoadFailed") {
                // Message.error(event.data.data.params.msg)
                console.log(event.data.data.params.msg);
            }
            loading.value = false;
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var confirmTitle = ref("");
        var confirmContent = ref("");
        var dialogTitle = ref("");
        var operationType = ref("");
        var isConfirm = ref(false);
        var isUpdate = ref(false);
        var isFrom = ref(false);
        var isUpload = ref(false);
        var isPublic = ref(false);
        var isUplow = ref(false);
        var saveLoading = ref(false);
        var uploadTableListConfig = ref([]);
        var fromRef = ref();
        var formThumbRef = ref();
        var fromSchemaData = reactive({
            fromSchema: {}
        });
        var fromModelData = reactive({
            fromModel: fromModel
        });
        var resource = computed(function() {
            return store.state.resource;
        });
        var showGoPt = computed(function() {
            return (Number(fromModelData.fromModel.type) === TabsType.PARTICLE || Number(fromModelData.fromModel.type) === TabsType.PRESETS) && resource.value.dialogFormInfo.operation === "revise";
        });
        var formConfig = computed(function() {
            return {
                inline: false,
                labelPosition: "right",
                labelWidth: "110px"
            };
        });
        watch(function() {
            return resource.value.dialogFormInfo;
        }, function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(val) {
                var _origin_name, _text, _media;
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            isConfirm.value = false;
                            isUpdate.value = false;
                            isFrom.value = false;
                            isUpload.value = false;
                            isPublic.value = false;
                            isUplow.value = false;
                            operationType.value = val.operation;
                            if (val.operation === Operation.DELETE) {
                                confirmTitle.value = "\u786E\u5B9A\u5220\u9664\u8D44\u6E90\u5417?";
                            }
                            if (val.operation === Operation.BATCHDE) {
                                confirmTitle.value = "\u786E\u5B9A\u6279\u91CF\u5220\u9664\u8D44\u6E90\u5417?";
                            }
                            if (val.operation === Operation.BATCHUPLOAD) {
                                isUpload.value = true;
                                dialogTitle.value = "\u6279\u91CF\u4E0A\u4F20";
                            }
                            if (val.operation === Operation.SINUPLOAD) {
                                isFrom.value = true;
                                dialogTitle.value = "\u8D44\u6E90\u65B0\u589E";
                            }
                            if (val.operation === Operation.REVISE) {
                                isFrom.value = true;
                                dialogTitle.value = "\u8D44\u6E90\u7F16\u8F91";
                            }
                            if (val.operation === Operation.DELETE || val.operation === Operation.BATCHDE) {
                                isConfirm.value = true;
                                confirmContent.value = "\u786E\u5B9A\u5220\u9664\u8D44\u6E90\u5417?\u5220\u9664\u540E,\u5DF2\u4F7F\u7528\u8BE5\u8D44\u6E90\u5B8C\u6210\u7684\u8BBE\u8BA1\u9879\u76EE\u53EF\u80FD\u4E0D\u80FD\u6B63\u5E38\u5C55\u793A\u3002\u6B64\u64CD\u4F5C\u4E0D\u53EF\u6062\u590D\uFF0C\u8BF7\u786E\u8BA4\u3002";
                            }
                            if (val.operation === Operation.ISOPEN || val.operation === Operation.UPLOW || val.operation === Operation.COPYRIGHT || val.operation === Operation.APPLICABLETOOL || val.operation === Operation.ADDLABEL || val.operation === Operation.DELABEL || val.operation === Operation.TAGS || val.operation === Operation.AUDIT) {
                                isUpdate.value = true;
                                dialogTitle.value = "\u6279\u91CF\u4FEE\u6539";
                            }
                            if (val.operation === Operation.ADD_PARTICLE) {
                                // 新增粒子的默认值，并且不可以编辑
                                isFrom.value = true;
                                dialogTitle.value = "\u65B0\u589E\u7C92\u5B50";
                                fromModelData.fromModel = _objectSpreadProps(_objectSpread({}, fromModel), {
                                    type: 5,
                                    show_status: 1,
                                    realize_method: 1,
                                    applicable_tools: [
                                        1
                                    ]
                                });
                                fromSchemaData.fromSchema = fromSchemaFun(TabsType.PARTICLE, val, fromModelData.fromModel);
                                resetForm();
                            }
                            // assets-factory 资源上传
                            if (val.operation === Operation.AF_UPLOAD) {
                                // 新增文本预设的默认值，并且不可以编辑
                                isFrom.value = true;
                                dialogTitle.value = "\u65B0\u5EFA\u8D44\u6E90";
                                fromModelData.fromModel = _objectSpreadProps(_objectSpread({}, fromModel), {
                                    type: val.type
                                });
                                if (val.thumb_obj) {
                                    fromModelData.fromModel.thumb_url = val.thumb_obj.thumb_url;
                                    fromModelData.fromModel.thumbList = val.thumb_obj.thumbList;
                                }
                                if (val.file_obj) {
                                    fromModelData.fromModel.file_url = val.file_obj.file_url;
                                    fromModelData.fromModel.fileList = val.file_obj.fileList;
                                }
                                fromSchemaData.fromSchema = fromSchemaFun(val.type, val, fromModelData.fromModel);
                                resetForm();
                            }
                            // 修改资源
                            if (val.operation === Operation.REVISE) {
                                ;
                                fromModelData.fromModel = _.assign(_.pick(val, [
                                    "name",
                                    "name_en",
                                    "type",
                                    "id",
                                    "public",
                                    "show_status",
                                    "copyright",
                                    "realize_method",
                                    "thumb_url",
                                    "file_url",
                                    "description",
                                    "flower_word_type",
                                    "cartoon_type",
                                    "skeleton_type", 
                                ]), {
                                    thumbList: [],
                                    // thumbStickerList: [],
                                    thumbTextList: [],
                                    origin_name: (_origin_name = val.file_meta.origin_name) !== null && _origin_name !== void 0 ? _origin_name : "",
                                    tag_ids: val.tag_ids ? val.tag_ids.split(",") : [],
                                    ai_tag_ids: val.ai_tag_ids ? val.ai_tag_ids.split(",") : [],
                                    languages: val.languages ? val.languages.split(",") : [],
                                    applicable_tools: val.applicable_tools ? val.applicable_tools.split(",").map(Number) : [],
                                    // thumb_url_sticker: val.cartoon_thumb.sticker ?? '',
                                    thumb_url_text: (_text = val.cartoon_thumb.text) !== null && _text !== void 0 ? _text : "",
                                    adapter_resources: val.adapter_resources ? val.adapter_resources.split(",").map(Number) : []
                                });
                                fromSchemaData.fromSchema = fromSchemaFun(val.type, val, fromModelData.fromModel);
                                if (val.type === TabsType.ANIMATION) {
                                    ;
                                    fromModelData.fromModel.thumb_url = (_media = val.cartoon_thumb.media) !== null && _media !== void 0 ? _media : "";
                                    if (val.cartoon_thumb.media) {
                                        getUrlList(val.cartoon_thumb.media, "thumb_url", "thumbList");
                                    }
                                    // if (val.cartoon_thumb.sticker) {
                                    //   getUrlList(
                                    //     val.cartoon_thumb.sticker,
                                    //     'thumb_url_sticker',
                                    //     'thumbStickerList',
                                    //   )
                                    // }
                                    if (val.cartoon_thumb.text) {
                                        getUrlList(val.cartoon_thumb.text, "thumb_url_text", "thumbTextList");
                                    }
                                } else {
                                    if (val.thumb_url) {
                                        getUrlList(val.thumb_url, "thumb_url", "thumbList");
                                    }
                                }
                                if (val.file_url) {
                                    getUrlList(val.file_url, "file_url", "fileList");
                                }
                                if (val.type === TabsType.MODEL) {
                                    nextTick(function() {
                                        var modelUrl = (val.preview_urls || []).find(function(url) {
                                            return getFileExtension(url) === "glb" || getFileExtension(url) === "gltf";
                                        }) || "";
                                        if (modelUrl) {
                                            loading.value = true;
                                            getModelIfrInfo(modelUrl);
                                        }
                                    });
                                }
                            // 上传资源
                            } else if (val.operation === Operation.SINUPLOAD) {
                                fromModelData.fromModel = _objectSpread({}, fromModel);
                                fromSchemaData.fromSchema = fromSchemaFun(resource.value.activeTab, val, fromModelData.fromModel);
                                fromModelData.fromModel.type = resource.value.activeTab === TabsType.ALL ? "" : resource.value.activeTab;
                                resetForm();
                            }
                        case 17:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(val) {
                return _ref.apply(this, arguments);
            };
        }(), {
            deep: true
        });
        var dialogVisible = computed({
            get: function() {
                return resource.value.visible;
            },
            set: function(val) {
                resetForm() // 关闭dialog时，清空校验
                ;
                store.commit("resource/updateVisible", val);
                isUpload.value = false // 关闭批量上传
                ;
            }
        });
        var dialogAttrs = computed(function() {
            return _objectSpread({
                title: isConfirm.value ? "" : dialogTitle.value,
                width: isFrom.value || isUpload.value ? "1020px" : "450px",
                center: isConfirm.value === true
            }, attrs);
        });
        var updateParams = computed(function() {
            var _field;
            return {
                ids: resource.value.dialogFormInfo.id,
                field: (_field = resource.value.dialogFormInfo.field) !== null && _field !== void 0 ? _field : resource.value.dialogFormInfo.operation,
                value: resource.value.dialogFormInfo.value,
                action: resource.value.dialogFormInfo.action,
                remark: resource.value.dialogFormInfo.remark
            };
        });
        var successForm = function() {
            Message.success("\u64CD\u4F5C\u6210\u529F");
            saveLoading.value = false;
            store.commit("resource/updateVisible", false);
            emit("refreshAssetList");
            isUpload.value = false // 关闭批量上传
            ;
        };
        var handleBatchChange = function(uploadTableList) {
            uploadTableListConfig.value = uploadTableList;
        };
        var clearFileUrl = function() {
            // fromModelData.fromModel.thumb_url_sticker = ''
            fromModelData.fromModel.thumb_url_text = "";
            fromModelData.fromModel.thumb_url = "";
            fromModelData.fromModel.thumbList = [];
            // fromModelData.fromModel.thumbStickerList = []
            fromModelData.fromModel.thumbTextList = [];
        };
        var handleChange = function() {
            var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(obj) {
                return regeneratorRuntime.wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (obj.prop === "type") {
                                fromModelData.fromModel.file_url = "";
                                fromModelData.fromModel.fileList = [];
                                fromSchemaData.fromSchema = fromSchemaFun(obj.value, resource.value.dialogFormInfo, fromModelData.fromModel);
                                // fromSchemaData.fromSchema.properties.type.visible = true
                                fromModelData.fromModel.applicable_tools = [];
                            } else if (obj.prop === "adapter_resources") {
                                fromModelData.fromModel.cartoon_type = 0;
                                clearFileUrl();
                            }
                        case 1:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function handleChange(obj) {
                return _ref.apply(this, arguments);
            };
        }();
        var goPt = function(asset_id) {
            var assetId = typeof asset_id === "number" ? asset_id : resource.value.dialogFormInfo.id;
            var assetType = Number(fromModelData.fromModel.type) === TabsType.PARTICLE ? "particle" // 粒子
             : "scene" // 预设
            ;
            window.open("".concat(playTurboHostList[NODE_ENV]).concat(playsmartEntry, "#/workbench?id=10000&asset_id=").concat(assetId, "&asset_type=").concat(assetType, "&new_resource=true"));
        };
        var handleSaveAsset = function() {
            var _ref1 = _asyncToGenerator(regeneratorRuntime.mark(function _callee1() {
                var ids, delete_ids, params1, _$ref, validateList, paramUploadTableList;
                return regeneratorRuntime.wrap(function _callee$(_ctx1) {
                    while(1)switch(_ctx1.prev = _ctx1.next){
                        case 0:
                            saveLoading.value = true;
                            if (!(isPublic.value || isUplow.value)) {
                                _ctx1.next = 25;
                                break;
                            }
                            if (!(resource.value.activeTab === TabsType.FRAGMENT)) {
                                _ctx1.next = 14;
                                break;
                            }
                            _ctx1.prev = 3;
                            _ctx1.next = 6;
                            return templateStatus({
                                ids: updateParams.value.ids.split(",").map(Number),
                                project_type: "fragment",
                                status: Number(updateParams.value.value)
                            });
                        case 6:
                            successForm();
                            _ctx1.next = 12;
                            break;
                        case 9:
                            _ctx1.prev = 9;
                            _ctx1.t0 = _ctx1["catch"](3);
                            saveLoading.value = false;
                        case 12:
                            _ctx1.next = 23;
                            break;
                        case 14:
                            _ctx1.prev = 14;
                            _ctx1.next = 17;
                            return updateAsset(updateParams.value);
                        case 17:
                            successForm();
                            _ctx1.next = 23;
                            break;
                        case 20:
                            _ctx1.prev = 20;
                            _ctx1.t1 = _ctx1["catch"](14);
                            saveLoading.value = false;
                        case 23:
                            _ctx1.next = 113;
                            break;
                        case 25:
                            if (!isConfirm.value) {
                                _ctx1.next = 45;
                                break;
                            }
                            _ctx1.prev = 26;
                            if (!(resource.value.activeTab === TabsType.FRAGMENT)) {
                                _ctx1.next = 35;
                                break;
                            }
                            ids = resource.value.dialogFormInfo.id;
                            delete_ids = typeof ids === "number" ? [
                                ids
                            ] : ids.split(",").map(Number);
                            _ctx1.next = 32;
                            return updateFragment({
                                delete_ids: delete_ids
                            });
                        case 32:
                            successForm();
                            _ctx1.next = 38;
                            break;
                        case 35:
                            _ctx1.next = 37;
                            return delAsset({
                                ids: String(resource.value.dialogFormInfo.id)
                            });
                        case 37:
                            successForm();
                        case 38:
                            _ctx1.next = 43;
                            break;
                        case 40:
                            _ctx1.prev = 40;
                            _ctx1.t2 = _ctx1["catch"](26);
                            saveLoading.value = false;
                        case 43:
                            _ctx1.next = 113;
                            break;
                        case 45:
                            if (!isUpdate.value) {
                                _ctx1.next = 78;
                                break;
                            }
                            if (!(operationType.value === Operation.ISOPEN)) {
                                _ctx1.next = 50;
                                break;
                            }
                            {
                                isConfirm.value = true;
                                isPublic.value = true;
                                isUplow.value = false;
                                saveLoading.value = false;
                                confirmTitle.value = "\u786E\u5B9A\u4FEE\u6539\u8D44\u6E90\u516C\u5F00\u72B6\u6001\u5417?";
                                confirmContent.value = "\u786E\u8BA4\u4FEE\u6539\u8D44\u6E90\u516C\u5F00\u72B6\u6001\u5417?\u516C\u5F00\u7684\u8D44\u6E90\u4E0A\u67B6\u540E\uFF0C\u6240\u6709\u7528\u6237\u53EF\u4F7F\u7528\uFF0C\u4E0D\u516C\u5F00\u7684\u8D44\u6E90\u4E0A\u67B6\u540E\uFF0C\u53EA\u6709\u5185\u90E8\u7528\u6237\u53EF\u4F7F\u7528\u3002\u8BF7\u786E\u8BA4\u3002";
                            }
                            _ctx1.next = 76;
                            break;
                        case 50:
                            if (!(operationType.value === Operation.UPLOW)) {
                                _ctx1.next = 54;
                                break;
                            }
                            {
                                isConfirm.value = true;
                                isPublic.value = false;
                                isUplow.value = true;
                                saveLoading.value = false;
                                confirmTitle.value = "\u786E\u5B9A\u4FEE\u6539\u8D44\u6E90\u4E0A\u4E0B\u67B6\u72B6\u6001\u5417?";
                                confirmContent.value = "\u786E\u8BA4\u4FEE\u6539\u8D44\u6E90\u4E0A\u4E0B\u67B6\u72B6\u6001\u5417?\u8D44\u6E90\u4E0A\u67B6\u540E\uFF0C\u8D44\u6E90\u4F1A\u5728\u5DE5\u5177\u524D\u53F0\u516C\u5171\u7D20\u6750\u5E93\u4E2D\u5C55\u793A\u5E76\u88AB\u5DE5\u5177\u7528\u6237\u4F7F\u7528\u3002\u8BF7\u786E\u8BA4\u3002";
                            }
                            _ctx1.next = 76;
                            break;
                        case 54:
                            if (!(operationType.value === Operation.AUDIT)) {
                                _ctx1.next = 58;
                                break;
                            }
                            {
                                params1 = {
                                    audit_status: updateParams.value.value,
                                    ids: updateParams.value.ids.split(",").map(Number),
                                    project_type: "fragment",
                                    remark: updateParams.value.remark
                                };
                                templateAudit(params1).then(function() {
                                    successForm();
                                }).finally(function() {
                                    saveLoading.value = false;
                                });
                            // 片段修改标签
                            }
                            _ctx1.next = 76;
                            break;
                        case 58:
                            if (!(operationType.value === Operation.TAGS)) {
                                _ctx1.next = 62;
                                break;
                            }
                            {
                                updateFragment({
                                    ids: updateParams.value.ids.split(",").map(Number),
                                    tag_ids: updateParams.value.value.split(",")
                                }).then(function() {
                                    successForm();
                                }).finally(function() {
                                    saveLoading.value = false;
                                });
                            }
                            _ctx1.next = 76;
                            break;
                        case 62:
                            _ctx1.prev = 62;
                            if (updateParams.value.field === "addLabel" || updateParams.value.field === "deLabel") {
                                updateParams.value.field = "tag_ids";
                                updateParams.value.action = updateParams.value.field === "addLabel" ? "add" : "del";
                            }
                            if (!updateParams.value.value) {
                                _ctx1.next = 70;
                                break;
                            }
                            _ctx1.next = 67;
                            return updateAsset(updateParams.value);
                        case 67:
                            successForm();
                            _ctx1.next = 71;
                            break;
                        case 70:
                            {
                                Message.error("\u8BF7\u9009\u62E9\u6570\u636E");
                                saveLoading.value = false;
                            }
                        case 71:
                            _ctx1.next = 76;
                            break;
                        case 73:
                            _ctx1.prev = 73;
                            _ctx1.t3 = _ctx1["catch"](62);
                            saveLoading.value = false;
                        case 76:
                            _ctx1.next = 113;
                            break;
                        case 78:
                            if (!isFrom.value) {
                                _ctx1.next = 93;
                                break;
                            }
                            ;
                            if (!validate3DModel()) {
                                _ctx1.next = 84;
                                break;
                            }
                            root.$message.error(validate3DModel());
                            saveLoading.value = false;
                            return _ctx1.abrupt("return");
                        case 84:
                            if (!validateModelAction()) {
                                _ctx1.next = 88;
                                break;
                            }
                            root.$message.error(validateModelAction());
                            saveLoading.value = false;
                            return _ctx1.abrupt("return");
                        case 88:
                            if (fromRef) {
                                _ctx1.next = 90;
                                break;
                            }
                            return _ctx1.abrupt("return");
                        case 90:
                            (_$ref = fromRef.value) === null || _$ref === void 0 ? void 0 : _$ref.validate(function() {
                                var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(valid) {
                                    var file_meta, params, res;
                                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                        while(1)switch(_ctx.prev = _ctx.next){
                                            case 0:
                                                if (!valid) {
                                                    _ctx.next = 23;
                                                    break;
                                                }
                                                if (fromModelData.fromModel.thumb_url && fromModelData.fromModel.thumb_url.indexOf("https") !== -1) {
                                                    delete fromModelData.fromModel.thumb_url;
                                                }
                                                if (fromModelData.fromModel.file_url && fromModelData.fromModel.file_url.indexOf("https") !== -1) {
                                                    delete fromModelData.fromModel.file_url;
                                                }
                                                // if (
                                                //   fromModelData.fromModel.thumb_url_sticker &&
                                                //   fromModelData.fromModel.thumb_url_sticker.indexOf('https') !== -1
                                                // ) {
                                                //   delete fromModelData.fromModel.thumb_url_sticker
                                                // }
                                                if (fromModelData.fromModel.thumb_url_text && fromModelData.fromModel.thumb_url_text.indexOf("https") !== -1) {
                                                    delete fromModelData.fromModel.thumb_url_text;
                                                }
                                                delete fromModelData.fromModel.fileList;
                                                delete fromModelData.fromModel.thumbList;
                                                // delete fromModelData.fromModel.thumbStickerList
                                                delete fromModelData.fromModel.thumbTextList;
                                                file_meta = {};
                                                if (fromModelData.fromModel.id && Number(fromModelData.fromModel.type) === TabsType.MODEL) {
                                                    // 模型库才会更新顶点数
                                                    file_meta = _.pick(fromModelData.fromModel.file_meta, [
                                                        "vertex_count", 
                                                    ]);
                                                } else if (!fromModelData.fromModel.id) {
                                                    file_meta = _.pick(fromModelData.fromModel.file_meta, [
                                                        "mesh_count",
                                                        "material_count",
                                                        "skin_count",
                                                        "skeleton_count",
                                                        "skeleton_names",
                                                        "face_count",
                                                        "vertex_count",
                                                        "fps",
                                                        "frames", 
                                                    ]);
                                                }
                                                params = _objectSpreadProps(_objectSpread(_objectSpreadProps(_objectSpread({}, fromModelData.fromModel), {
                                                    id: resource.value.dialogFormInfo.id,
                                                    type: fromModelData.fromModel.type === "" ? resource.value.dialogFormInfo.type : fromModelData.fromModel.type,
                                                    languages: fromModelData.fromModel.languages.toString(),
                                                    applicable_tools: fromModelData.fromModel.applicable_tools.toString(),
                                                    tag_ids: fromModelData.fromModel.tag_ids.toString()
                                                }), fromModelData.fromModel.ai_tag_ids ? {
                                                    ai_tag_ids: fromModelData.fromModel.ai_tag_ids.toString()
                                                } : {}), {
                                                    adapter_resources: fromModelData.fromModel.adapter_resources.toString(),
                                                    file_meta: JSON.stringify(file_meta)
                                                });
                                                _ctx.prev = 10;
                                                _ctx.next = 13;
                                                return saveAsset(params);
                                            case 13:
                                                res = _ctx.sent;
                                                if (res.data.code === 0) {
                                                    if (resource.value.dialogFormInfo.operation === Operation.ADD_PARTICLE) {
                                                        goPt(Number(res.data.data.id));
                                                    }
                                                }
                                                successForm();
                                                _ctx.next = 21;
                                                break;
                                            case 18:
                                                _ctx.prev = 18;
                                                _ctx.t0 = _ctx["catch"](10);
                                                saveLoading.value = false;
                                            case 21:
                                                _ctx.next = 24;
                                                break;
                                            case 23:
                                                {
                                                    saveLoading.value = false;
                                                }
                                            case 24:
                                            case "end":
                                                return _ctx.stop();
                                        }
                                    }, _callee, null, [
                                        [
                                            10,
                                            18
                                        ]
                                    ]);
                                }));
                                return function(valid) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                            _ctx1.next = 113;
                            break;
                        case 93:
                            if (!isUpload.value) {
                                _ctx1.next = 113;
                                break;
                            }
                            if (uploadTableListConfig.value.length) {
                                _ctx1.next = 98;
                                break;
                            }
                            {
                                Message.error("\u8BF7\u9009\u62E9\u6587\u4EF6");
                            }
                            _ctx1.next = 113;
                            break;
                        case 98:
                            validateList = _.filter(uploadTableListConfig.value, function(item) {
                                return !item.name || !item.name_en;
                            });
                            if (!validateList.length) {
                                _ctx1.next = 102;
                                break;
                            }
                            saveLoading.value = false;
                            return _ctx1.abrupt("return", false);
                        case 102:
                            paramUploadTableList = _.cloneDeep(uploadTableListConfig.value);
                            paramUploadTableList.map(function(e) {
                                delete e.type;
                                delete e.access_allow_pt;
                                delete e.applicable_tools_apply_to_all;
                                delete e.realize_method_apply_to_all;
                                if (e.realize_method === "") {
                                    e.realize_method = 0;
                                }
                                e.tag_ids = String(e.tag_ids);
                                if (typeof e.applicable_tools !== "undefined") {
                                    e.applicable_tools = String(e.applicable_tools);
                                }
                            });
                            _ctx1.prev = 104;
                            _ctx1.next = 107;
                            return batchCreateAsset({
                                type: resource.value.activeTab,
                                assets: JSON.stringify(paramUploadTableList)
                            });
                        case 107:
                            successForm();
                            _ctx1.next = 113;
                            break;
                        case 110:
                            _ctx1.prev = 110;
                            _ctx1.t4 = _ctx1["catch"](104);
                            saveLoading.value = false;
                        case 113:
                        case "end":
                            return _ctx1.stop();
                    }
                }, _callee1, null, [
                    [
                        3,
                        9
                    ],
                    [
                        14,
                        20
                    ],
                    [
                        26,
                        40
                    ],
                    [
                        62,
                        73
                    ],
                    [
                        104,
                        110
                    ]
                ]);
            }));
            return function handleSaveAsset() {
                return _ref1.apply(this, arguments);
            };
        }();
        onMounted(function() {
            window.addEventListener("message", getModelBasicInfo);
        });
        onUnmounted(function() {
            window.removeEventListener("message", getModelBasicInfo);
        });
        return _objectSpreadProps(_objectSpread({}, toRefs(fromSchemaData), toRefs(fromModelData)), {
            fromRef: fromRef,
            formThumbRef: formThumbRef,
            formConfig: formConfig,
            dialogVisible: dialogVisible,
            dialogAttrs: dialogAttrs,
            isConfirm: isConfirm,
            isUpdate: isUpdate,
            isFrom: isFrom,
            isUpload: isUpload,
            isPublic: isPublic,
            isUplow: isUplow,
            showGoPt: showGoPt,
            dialogTitle: dialogTitle,
            confirmTitle: confirmTitle,
            confirmContent: confirmContent,
            operationType: operationType,
            saveLoading: saveLoading,
            loading: loading,
            goPt: goPt,
            handleChange: handleChange,
            handleSaveAsset: handleSaveAsset,
            handleBatchChange: handleBatchChange
        });
    }
});
